var React = require('react');

function Shield (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#F8E71C","fillRule":"evenodd","d":"M18.04 10.87l-2.993 2.342 1.128 3.651c.065.208-.03.427-.233.547a.635.635 0 0 1-.665-.02l-3.312-2.251-3.312 2.266a.633.633 0 0 1-.665.023c-.206-.119-.3-.339-.235-.547l1.128-3.674-2.992-2.336a.461.461 0 0 1-.155-.551c.084-.195.296-.324.533-.324h3.682l1.486-3.256c.171-.38.886-.38 1.058 0l1.485 3.256h3.683c.236 0 .449.129.532.324a.46.46 0 0 1-.153.55m5.466-6.337c-.083-.02-8.431-2.018-11.13-4.392-.214-.188-.61-.188-.823 0C8.853 2.515.505 4.513.422 4.533c-.25.06-.422.256-.422.482 0 8.571.867 15.41 11.766 18.954a.64.64 0 0 0 .396 0c10.899-3.545 11.766-10.383 11.766-18.954 0-.226-.172-.423-.422-.482"}));
}

Shield.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Shield;

Shield.default = Shield;



// WEBPACK FOOTER //
// ./src/Assets/Icons/shield.svg